import React from "react"

import classNames from "src/classNames"

type NameListProps = {
  heading: string
  headingClassNames?: string
  names: string[]
}

const NameList = ({ heading, headingClassNames, names }: NameListProps) => (
  <div className="rounded-lg bg-neutral-900 p-3">
    <p className={classNames("mb-2 text-sm font-semibold", headingClassNames)}>
      {heading}
    </p>
    {names.length > 0 ? (
      <ul className="space-y-1 text-sm text-neutral-300">
        {names.map((name, i) => (
          <li key={`${name}-${i}`}>{name}</li>
        ))}
      </ul>
    ) : (
      <p className="text-sm italic text-neutral-500">None</p>
    )}
  </div>
)

export default NameList
